export const isInitialApiSecret = (apiSecret) => apiSecret.includes('*****');
